import { createApp } from "vue";
import Axios from "axios";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";
import XtraVisualHelper from "@Scripts/Infrastructure/XtraVisualHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Seo", "CookieToast"]
        });

        this.initRequestVerificationToken();

        const app = createApp({});
        (<any>app).config.devtools = false;

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            app.use(DataWeb.default);
            app.use(DataWebConfig);

            DataWeb.default.registerRoutes(router);
            DataWeb.default.registerStoreModules(store);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        app.use(router).use(store).use(AppConfig);

        (<any>window).App.instances.vm = app.mount('#app');

        this.setTopMenu();
        this.setVisuals();
        this.setFancybox();

        this.onResize();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    public static device = {
        isSmartphone: window.matchMedia("screen and (max-width:749px)"),
        isTablet: window.matchMedia("screen and (min-width:750px) and (max-width:1010px)"),
        isUserAgentIOS: navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)/i),
        isUserAgentWinPh: navigator.userAgent.match(/(Windows Phone OS 7)|(IEMobile)/i),
        isUserAgentMobile: navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(Windows Phone OS 7)|(IEMobile)|(webOS)/i)
    };

    public static onResize() {
        $(".mpopup-layer").width(window.innerWidth);
        this.setWrapmenu();
        this.setSubpagesSelected();
        this.setSubpagesExpanding();

        if ((<any>window).App?.bag?.area === "Home") {
            this.setCarouselOffers();
        };

        const self = this;
        window.addEventListener("resize", function (event) {
            $(".mpopup-layer").width(window.innerWidth);
            self.setWrapmenu();
            self.setSubpagesSelected();
            self.setSubpagesExpanding();

            if ((<any>window).App?.bag?.area === "Home") {
                self.setCarouselOffers();
            };
        }, true);
    }

    public static setCarouselOffers() {
        var $Carousel = $("#CarouselPhoto"),
            $Carousel_Pagination = $("#CarouselPhoto .Pagination"),
            $Carousel_Items = $(".Items", $Carousel),
            $Carousel_NavPrev = $(".NavPrev", $Carousel),
            $Carousel_NavNext = $(".NavNext", $Carousel),
            DurationScroll = 1000;

        if (!this.device.isSmartphone.matches) {
            (<any>window).$Carousel_Items.carouFredSel({
                responsive: true,
                width: '100%',
                scroll: 1,
                direction: "left",
                items: {
                    visible: {
                        min: 0,
                        max: 1
                    }
                },
                swipe: {
                    onMouse: true,
                    onTouch: true
                },
                prev: {
                    button: $Carousel_NavNext,
                    duration: DurationScroll
                },
                next: {
                    button: $Carousel_NavPrev,
                    duration: DurationScroll
                },
                auto: {
                    delay: 0,
                    duration: DurationScroll,
                    pauseDuration: 5000
                }
            });
        }
        else {
            $Carousel_Items.trigger('destroy');
        }
    };

    public static setSubpagesSelected() {
        var $pageSubmenu = $(".page-submenu"),
            $buttonPageCurrent = $(".container .button[data-page=\"" + (<any>window).App?.bag?.page + "\"]", $pageSubmenu);

        $buttonPageCurrent.attr("data-selected", "True");
    };

    public static setSubpagesExpanding() {
        var $pageSubmenuSelect = $(".page-submenu-select"),
            $iconOpen = $(".fa-chevron-down", $pageSubmenuSelect),
            $iconClose = $(".fa-chevron-up", $pageSubmenuSelect),
            $pageSubmenu = $(".page-submenu");

        if (this.device.isSmartphone.matches) {
            $pageSubmenuSelect.show();
            $iconOpen.hide();
            $iconClose.show();
            $pageSubmenu.hide();

            $pageSubmenuSelect.unbind().bind("click", function () {
                $pageSubmenu.stop(true, true).slideToggle(function () {
                    if (!$pageSubmenu.is(":hidden")) {
                        $iconOpen.show();
                        $iconClose.hide();
                        $pageSubmenuSelect.addClass("page-submenu-open");

                    } else {
                        $iconOpen.hide();
                        $iconClose.show();
                        $pageSubmenuSelect.removeClass("page-submenu-open");
                    }
                });
            });
        }
        else {
            $pageSubmenuSelect.hide();
            $pageSubmenu.show();
        };
    };

    public static setWrapmenu() {
        var isOpen = false,
            $wrapmenu = $(".wrapmenu"),
            $wrapmenuTap = $(".wrapmenu-tap"),
            $wrapmenuButton = $(".wrapmenu-button"),
            $wrapmenuButtonClose = $(".wrapmenu-buttonclose");

        if (this.device.isSmartphone.matches) {
            $wrapmenuTap.on("click", function (event) {
                closeMenu();
                event.stopPropagation();
            });
            $wrapmenuButtonClose.on("click", function (event) {
                closeMenu();
                event.stopPropagation();
            });
            $wrapmenuButton.on("click", function (event) {
                toggleMenu();
                event.stopPropagation();
            });
            $wrapmenu.on("click", function (event) {
                event.stopPropagation();
            });
        } else {
            $wrapmenu.removeClass("anim-wrapmenuclose anim-wrapmenuopen");
            $wrapmenuTap.hide();
        }

        function openMenu() {
            if (!isOpen) {
                isOpen = true;
                $wrapmenuTap.show();
                $wrapmenu.removeClass("anim-wrapmenuclose").addClass("anim-wrapmenuopen");
            }
        };

        function closeMenu() {
            if (isOpen) {
                isOpen = false;
                $wrapmenuTap.hide();
                $wrapmenu.removeClass("anim-wrapmenuopen").addClass("anim-wrapmenuclose");
            }
        };

        function toggleMenu() {
            if (!isOpen) {
                isOpen = true;
                $wrapmenuTap.show();
                $wrapmenu.removeClass("anim-wrapmenuclose").addClass("anim-wrapmenuopen");
            } else {
                isOpen = false;
                $wrapmenuTap.hide();
                $wrapmenu.removeClass("anim-wrapmenuopen").addClass("anim-wrapmenuclose");
            }
        };
    };

    private static setTopMenu() {
        var $appHeader = $(".app-header"),
            $welcomeUser = $("#WelcomeUser", $appHeader),
            $logout = $("#Logout", $appHeader),
            $reservedArea = $("#ReservedArea", $appHeader),
            $buttonCorporateCurrent = $(".menu-buttonarea .button[data-area=\"" + (<any>window).App?.bag?.area + "\"]", $appHeader);

        $buttonCorporateCurrent.attr("data-selected", "True");

        $(".localizations").unbind().bind("click", function () {
            $(".buttons").stop(true, true).slideToggle();
        });

        $logout.hide();
        $reservedArea.hide();
        $welcomeUser.on("click", function () {
            $logout.stop(true, true).slideToggle();
            $reservedArea.stop(true, true).slideToggle();
        });
    };

    private static setVisuals() {
        XtraVisualHelper.init();

        (<any>window).$(".visual-area").xtraVisual({
            timerInterval: 10000,
            isVisualLoaderEnabled: true,
            isSelectorEnabled: false,
            isTimerEnabled: true,
            isImageBackground: true,
            isSkinBackground: false,
            isSkinFullScreen: false
        });
    };

    private static setFancybox() {
        const self = this;
        let btnHtmlClose = "<div title=\"Close\" class=\"mpopup-btn\" data-type=\"close\"><span class=\"icon-cross\"></span></div>";
        let btnHtmlNext = "<div title=\"Next\" class=\"mpopup-btn\" data-type=\"next\"><span class=\"fa fa-angle-right\"></span></div>";
        let btnHtmlPrev = "<div title=\"Previous\" class=\"mpopup-btn\" data-type=\"prev\"><span class=\"fa fa-angle-left\"></span></div>";

        (<any>window).$(".fncyb-gallery").fancybox({
            padding: 0,
            width: "100%",
            margin: [40, 0, 40, 0],
            closeBtn: true,
            tpl: {
                closeBtn: btnHtmlClose,
                next: btnHtmlNext,
                prev: btnHtmlPrev
            },
            scrollOutside: false,
            transitionIn: "fade",
            transitionOut: "fade",
            prevEffect: "fade",
            nextEffect: "fade",
            changeFade: 0,
            afterShow: function () {
                setSwipe(".fancybox-skin img");
            }
        });

        (<any>window).$(".fncyb-terms").fancybox({
            padding: [20, 0, 20, 0],
            width: "100%",
            margin: [40, 0, 40, 0],
            closeBtn: true,
            tpl: {
                closeBtn: btnHtmlClose
            },
            scrollOutside: false,
            transitionIn: "fade",
            transitionOut: "fade",
            prevEffect: "fade",
            nextEffect: "fade",
            changeFade: 0,
            afterClose: function () { $("#IsTermsAgreement").attr('checked'); }
        });

        function setSwipe(element) {
            var gesture = {
                left: "swipeleft",
                right: "swiperight",
                doubletap: "doubletap"
            },
                hammerOptions = {
                    prevent_default: true,
                    no_mouseevents: true
                };

            if (self.device.isUserAgentMobile) {
                gesture = {
                    left: "dragleft",
                    right: "dragright",
                    doubletap: "doubletap"
                }
            }

            (<any>window).$(element)
                .hammer(hammerOptions)
                .on(gesture.left, function (ev) {
                    (<any>window).$.fancybox.next();
                    ev.gesture.stopDetect();
                });

            (<any>window).$(element)
                .hammer(hammerOptions)
                .on(gesture.right, function (ev) {
                    (<any>window).$.fancybox.prev();
                    ev.gesture.stopDetect();
                });

            (<any>window).$(element)
                .hammer(hammerOptions)
                .on(gesture.doubletap, function (ev) {
                    (<any>window).$.fancybox.close();
                    ev.gesture.stopDetect();
                });
        }
    };
}